export var devideUnitPrice = function devideUnitPrice(priceUnit, deviderSignPriceUnit) {
  if (!deviderSignPriceUnit) {
    return [priceUnit, ''];
  }
  var from = priceUnit.search(deviderSignPriceUnit) || 0;
  var to = priceUnit.length;
  var unit = priceUnit.substring(from, to);
  var currency = priceUnit.substring(0, from);
  return [unit, currency];
};